import React, { useEffect, useState } from 'react';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import Select from 'react-select';
import Swal from 'sweetalert2';
import { generateAxiosInstance } from '../../hooks/useAuthorizedRequest';
import { generateAxiosInstanceSection } from '../../hooks/useAuthorizedRequestForSection';
import { generateAxiosInstanceInstitute } from '../../hooks/useAuthorizedRequestForInstitute';
import { generateAxiosInstanceCommon } from '../../hooks/useAuthorizedReuestCommon';
import { useNavigate } from 'react-router-dom';
import { Loader } from '../../components/ModalsCommonFunctions';
import { deleteItem, findPageNumber, searchArray, SortIcon } from '../../components/Navigation';
import Pagination from '../../components/Pagination';

const SectionSubjectDssReport = () => {
    const authorizedAxios = generateAxiosInstance()
    const authorizedAxiosSection = generateAxiosInstanceSection()
    const authorizedAxiosInstitute = generateAxiosInstanceInstitute()
    const authorizedAxiosCommon = generateAxiosInstanceCommon();
    let instituteMasterId = localStorage.getItem("instituteMasterId");
    let sectionMasterId = localStorage.getItem("sectionMasterId");

    const [subjectDssReport, setSubjectDssReport] = useState([]);
    const [gradeList, setGradeList] = useState([]);
    const [instituteGradeMasterId, setInstituteGradeMasterId] = useState("");

    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const handleNavigate = (route) => {
        navigate(route);
    };

    useEffect(() => {
        getGradeList()
    }, [])

    useEffect(() => {
        getSubjectDssReport();
    }, [instituteGradeMasterId]);

    const getGradeList = () => {
        const apiUrlForSyllabus = `/get-institute-grade?instituteMasterId=${instituteMasterId}`;
        authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrlForSyllabus)
            .then(response => {
                setGradeList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const getApiUrl = () => {
        let apiUrl = `/get-subject-dss-report?sectionMasterId=${sectionMasterId}&`;
        if (instituteGradeMasterId !== "" && instituteGradeMasterId !== "all" && instituteGradeMasterId !== null && instituteGradeMasterId !== undefined) {
            apiUrl += `instituteGradeMasterId=${instituteGradeMasterId}&`;
        }

        apiUrl = apiUrl.replace(/&$/, '');
        return apiUrl;
    }

    const getSubjectDssReport = async () => {
        try {
            // const apiUrl = `/get-subject-dss-report`;
            const response = await authorizedAxiosCommon.get(getApiUrl())
            setSubjectDssReport(response.data.result)
        } catch (error) {
            const errorMsg = error?.response?.data?.message || 'Something went wrong!';
            console.error('Error fetching data:', errorMsg);
        }
    }

    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <Header />
                <div id='scroll-up'></div>
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb my-0 ms-2">
                        <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/section-dashboard')}>
                            <span>Dashboard</span>
                        </li>
                        <li className="breadcrumb-item active"><span>Subject DSS Report</span></li>
                    </ol>
                </nav>
                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fas fa-book-open"></i>Subject DSS Report</b></h4>
                                </div>
                                <div className="card-body ">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="col-md-12">
                                                <label for="instituteGradeMasterId" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Class :</label>
                                                <select class="form-select" aria-label="Default select example" name='instituteGradeMasterId' onChange={(e) => setInstituteGradeMasterId(e.target.value)} value={instituteGradeMasterId}>
                                                    <option selected value={''} disabled>Select Class</option>
                                                    <option value="all">All</option>
                                                    {
                                                        gradeList?.map((grade) => {
                                                            return <option value={grade.id}>{grade.gradeName}</option>
                                                        })
                                                    }
                                                </select>
                                            </div>

                                            <div className="row">
                                                <div className="d-grid gap-2 mt-2">
                                                    <div class="tab-content rounded-bottom custom_table">
                                                        <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
                                                        <table class="table">
                                                                <thead>
                                                                    <tr>
                                                                        <th rowSpan="2" scope="col" className='sl_no'>Sr. No.</th>
                                                                        <th rowSpan='2' scope='col'>Class</th>
                                                                        <th rowSpan="2" scope="col">Subject Name</th>
                                                                        {/* <th rowSpan="2" scope="col">Doubts Raised</th>
                                                                        <th rowSpan="2" scope="col">Doubts Pending</th> */}
                                                                        <th colSpan="5" scope="col" style={{ textAlign: 'center' }}>Text Chat</th>
                                                                        <th colSpan="5" scope="col" style={{ textAlign: 'center' }}>Video Chat</th>
                                                                    </tr>
                                                                    <tr>
                                                                        {/* Text Chat Headers */}
                                                                        <th scope="col">Chats Conducted</th>
                                                                        <th scope="col">Chats Running</th>
                                                                        <th scope="col">Doubts Resolved</th>
                                                                        <th scope="col">Pending Doubts</th>
                                                                        <th scope="col">Rejected Doubts</th>
                                                                        {/* Video Chat Headers */}
                                                                        <th scope="col">Chats Conducted</th>
                                                                        <th scope="col">Chats Running</th>
                                                                        <th scope="col">Doubts Resolved</th>
                                                                        <th scope="col">Pending Doubts</th>
                                                                        <th scope="col">Rejected Doubts</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {subjectDssReport?.length > 0 ? (
                                                                        subjectDssReport?.map((dss, index) => (
                                                                            <tr key={index}>
                                                                                <th scope="row" className='sl_no'>{index + 1}</th>
                                                                                <td>{dss.gradeName}</td>
                                                                                <td>{dss.subjectName}</td>
                                                                                {/* <td>{dss.doubtsRaised}</td>
                                                                                <td>{dss.doubtsPending}</td> */}
                                                                                {/* Text Chat */}
                                                                                <td>{dss.textChatsConducted}</td>
                                                                                <td>{dss.textChatsRunning}</td>
                                                                                <td>{dss.textChatsDoubtsResolved}</td>
                                                                                <td>{dss.textChatsPendingDoubts}</td>
                                                                                <td>{dss.textChatsRejectedDoubts}</td>
                                                                                {/* Video Chat */}
                                                                                <td>{dss.videoChatsConducted}</td>
                                                                                <td>{dss.videoChatsRunning}</td>
                                                                                <td>{dss.videoChatsDoubtsResolved}</td>
                                                                                <td>{dss.videoChatsPendingDoubts}</td>
                                                                                <td>{dss.videoChatsRejectedDoubts}</td>
                                                                            </tr>
                                                                        ))
                                                                    ) : (
                                                                        <tr>
                                                                            <th colSpan={"100%"} style={{ textAlign: 'center' }}>No Teacher Available</th>
                                                                        </tr>
                                                                    )}
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};

export default SectionSubjectDssReport;